import { useEffect, useState } from 'react'
import { Image, Button } from "react-bootstrap";
import {
  FaqSearch,
  HelpSection,
  WeHelp,
  HelpBox,
  BoxTitle,
  BoxText,
  HowHelp,
  BoxImage,
  KnowledgeBase,
  BoxContent,
  MostRecent,
  KnowledgeTitle,
  KnowledgeSmallText,
  ArticlesBox,
  ArticlesIcon,
  ArticlesText,
  Question,
  ArticlesButton,
  EllipsisText,
} from './FaqStyle';
import GreatNonprofits from '../../assests/images/greatnonprofits-heart.webp';
import DocumentIcon from '../../assests/images/document-text.svg';
import CustomSearch from '../../components/common/customSearch';
import { useDispatch, useSelector } from 'react-redux';
import { faqHelpsHandler } from '../../redux/slices/faq/faqHelps-slice';
import { faqArticlesHandler } from '../../redux/slices/faq/faqArticles-slice';
import { faqUserGuideHandler } from '../../redux/slices/faq/faqUserGuide-slice';
import { faqTopRatedAwardsHandler } from '../../redux/slices/faq/faqTopRatedAwards-slice';
import { faqNonprofitHandler } from '../../redux/slices/nonProfit/nonprofitFaq-slice';
import { MESSAGE } from '../../utils/message';

const FaqSupport = ({setTabKey}:any) => {
  const [searchValue, setSearchValue]= useState<string>('')
  const dispatch: any = useDispatch();
  const faqHelpsList = useSelector((state:any) => state?.faqHelps?.data)
  const faqArticlesList = useSelector((state:any) => state?.faqArticles?.data)
  
    useEffect(() =>{
      dispatch(faqHelpsHandler());
      dispatch(faqArticlesHandler());
      dispatch(faqUserGuideHandler());
      dispatch(faqTopRatedAwardsHandler());
      dispatch(faqNonprofitHandler());
    },[])
  return (
    <>
    <FaqSearch>
      <CustomSearch onSubmit={()=>{}}
            setSearchValue={setSearchValue}
            searchValue={searchValue} placeholder="Search GreatNonprofits Support Center..."/>
    </FaqSearch>
    
    <HelpSection>
        <HowHelp>
        <WeHelp>
            {faqHelpsList?.data?.map((faq:any, index:number) => (
            <HelpBox key={index+1}>
              <BoxImage><Image src={GreatNonprofits} /></BoxImage>
              <BoxContent>
                  <BoxTitle>{faq.title}</BoxTitle>
                  <BoxText>{faq.description}</BoxText>
              </BoxContent>
            </HelpBox>
            ))}
        </WeHelp>
        </HowHelp>
    </HelpSection>
    
    <KnowledgeBase>
        <MostRecent>
        <KnowledgeTitle>{MESSAGE.knowledgeBase}</KnowledgeTitle>
        <KnowledgeSmallText>{MESSAGE.quickGuide}</KnowledgeSmallText>
        <BoxText className="box-title-text">{MESSAGE.recentArticle}</BoxText>
            {faqArticlesList?.data?.slice(0,8)?.map((article:any, index:number) => (
            <ArticlesBox key={index+1}>
                <ArticlesIcon><Image src={DocumentIcon} /></ArticlesIcon>
                <ArticlesText>
                <Question>{article.question}</Question>
                <EllipsisText>{article.answer}</EllipsisText>
                </ArticlesText>
            </ArticlesBox>
            ))}
        <ArticlesButton><Button className="btn-outline-success-blue" onClick={() => setTabKey('solution')}>{MESSAGE.viewAllArticle}</Button></ArticlesButton>
        </MostRecent>
    </KnowledgeBase>
  </>
  )
}

export default FaqSupport
